export const filter = (target) => {
  const el = {
    select: target.querySelector('.filter__select'),
    selectInput: target.querySelector('.filter__select input'),
    checkboxes: target.querySelectorAll('.filter__dropdown input[type="checkbox"]'),
    clearButton: target.querySelector('.filter__dropdown-button'),
  }

  const method = {
    init: () => {
      el.select.addEventListener('click', method.toggleDropdown)
      el.checkboxes.forEach((checkbox) => checkbox.addEventListener('change', method.changeValue))
      el.clearButton.addEventListener('click', method.clearSelection)
    },

    isFilterActive: () => target.classList.contains('filter--open'),

    toggleDropdown: (event) => {
      event.preventDefault()

      if (method.isFilterActive()) {
        target.classList.remove('filter--open')
      } else {
        target.classList.add('filter--open')
        document.addEventListener('click', method.toggleDropdownOnOutsideClick)
      }
    },

    toggleDropdownOnOutsideClick: (event) => {
      // const isThisOpen = event.target.closest('.filter--open')
      const isThisOpen = event.target.closest(`.${target.classList[0]}`) === target

      if (method.isFilterActive() && !isThisOpen) {
        target.classList.remove('filter--open')
        document.removeEventListener('click', method.toggleDropdownOnOutsideClick)
      }
    },

    clearSelection: () => {
      el.checkboxes.forEach((input) => {
        input.checked = false
        el.selectInput.value = target.dataset.defaultValue
      })

      target.classList.remove('filter--open')
    },

    changeValue: (event) => {
      if (event.target.checked === true) {
        if (el.selectInput.value === target.dataset.defaultValue) {
          el.selectInput.value = event.target.value
        } else {
          el.selectInput.value = el.selectInput.value.concat(', ', event.target.value)
        }
      } else {
        if (el.selectInput.value.includes(event.target.value)) {
          let arr = el.selectInput.value.split(', ')
          arr.indexOf(event.target.value)
          arr = arr.filter((item) => item != event.target.value)
          el.selectInput.value =
            arr.length > 0
              ? arr.filter((item) => item != event.target.value).join(', ')
              : target.dataset.defaultValue
        }
      }
    },
  }

  method.init()
}
